var render = function render(){var _vm=this,_c=_vm._self._c;return _c('code-diff',{attrs:{"old-string":_vm.local,"new-string":_vm.git,"file-name":_vm.name,"context":10,"output-format":"side-by-side"}})
}
var staticRenderFns = []

export { render, staticRenderFns }